export default __webpack_public_path__ + "static/media/Error (1).984af94c.png";